import {createRequestDataSource} from '@ngneat/elf-requests';
import {jobsInvoiceStore} from '@store/invoices/jobsInvoice/jobsInvoice.store';
import {entitiesPropsFactory, selectAllEntities} from '@ngneat/elf-entities';
import {selectCurrentPageEntities} from '@ngneat/elf-pagination';

const {invoicesEntitiesRef} = entitiesPropsFactory('invoices');

export const getJobsInvoiceDataSource = createRequestDataSource({
  store: jobsInvoiceStore,
  data$: () => jobsInvoiceStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getJobsInvoiceDataSource',
  dataKey: 'jobsInvoice',
});

export const getJobInvoiceDetailsDataSource = createRequestDataSource({
  store: jobsInvoiceStore,
  data$: () => jobsInvoiceStore.pipe(selectAllEntities({ref: invoicesEntitiesRef})),
  requestKey: 'getJobInvoiceDetailsDataSource',
  dataKey: 'invoices',
});
